import { FormControlLabel, Switch } from '@material-ui/core';
import React from 'react';

export default function SwitchFavorecidoFornecedor({ handleChange, handleBlur, checked, disabled }) {
  return (
    <FormControlLabel
      label="Favorecido diferente do fornecedor"
      control={
        <Switch
          id="favorecidoDiferenteFornecedor"
          name="favorecidoDiferenteFornecedor"
          value={checked}
          checked={checked}
          onChange={handleChange}
          onBlur={handleBlur}
          size="small"
          color="primary"
          disabled={disabled}
        />
      }
    />
  );
}
